var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 191,
    viewBox: "0 0 203 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.539 76.8652H50.856V28.1948H92.539V76.8652Z",
    fill: "#FFB81C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.983 180.609C159.983 184.924 156.603 188.424 152.438 188.424H39.0529C34.8865 188.424 31.5112 184.924 31.5112 180.609V11.4547C31.5112 7.13752 34.8865 3.63769 39.0529 3.63769H152.438C156.603 3.63769 159.983 7.13752 159.983 11.4547V53.043",
    stroke: "white",
    strokeWidth: 4.67302,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5024 71.6484H45.8193V22.978H87.5024V71.6484Z",
    stroke: "white",
    strokeWidth: 4.67302,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5552 90.9521H121.043",
    stroke: "white",
    strokeWidth: 4.67302,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5552 112.781H112.265",
    stroke: "white",
    strokeWidth: 4.67302,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5552 134.609H101.732",
    stroke: "white",
    strokeWidth: 4.67302,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5552 158.257H94.7098",
    stroke: "white",
    strokeWidth: 4.67302,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.555 166.088L140.531 121.69L156.917 128.232L144.076 166.29C143.955 166.648 143.637 166.887 143.266 166.898L126.498 167.4C125.835 167.42 125.339 166.73 125.555 166.088Z",
    stroke: "white",
    strokeWidth: 5.73747
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M196.854 166.28L182.43 121.661L165.968 127.958L178.337 166.208C178.453 166.567 178.769 166.811 179.139 166.828L195.893 167.577C196.556 167.607 197.062 166.924 196.854 166.28Z",
    stroke: "white",
    strokeWidth: 5.73747
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M161.825 126.382C177.926 126.382 190.979 113.329 190.979 97.228C190.979 81.1265 177.926 68.0736 161.825 68.0736C145.724 68.0736 132.671 81.1265 132.671 97.228C132.671 113.329 145.724 126.382 161.825 126.382Z",
    fill: "#FFB81C",
    stroke: "white",
    strokeWidth: 5.73747
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.251 94.6612C181.921 94.0266 181.532 92.8977 180.613 92.8113L168.485 91.6705C168.08 91.6325 167.731 91.3693 167.584 90.9905L162.907 78.9724C162.552 78.0591 161.259 78.0594 160.904 78.9729L156.226 91.012C156.079 91.3916 155.729 91.6551 155.324 91.6927L143.205 92.8141C142.285 92.8993 141.894 94.03 142.566 94.6649L151.902 103.486C152.175 103.744 152.293 104.125 152.215 104.492L149.435 117.491C149.234 118.431 150.273 119.141 151.076 118.613L161.314 111.873C161.673 111.637 162.137 111.637 162.496 111.873L172.738 118.615C173.54 119.143 174.579 118.434 174.38 117.495L171.615 104.491C171.537 104.125 171.656 103.744 171.928 103.487L181.251 94.6612ZM162.496 107.577C162.138 107.34 161.672 107.34 161.314 107.577L156.175 110.96C155.372 111.489 154.332 110.778 154.534 109.838L155.964 103.159C156.043 102.792 155.925 102.411 155.652 102.154L150.817 97.5782C150.146 96.9438 150.535 95.8151 151.454 95.7281L157.663 95.1406C158.068 95.1023 158.417 94.8382 158.563 94.4585L160.905 88.4049C161.259 87.4896 162.553 87.4889 162.908 88.4038L165.267 94.4826C165.414 94.8616 165.763 95.1252 166.168 95.1635L172.377 95.7511C173.296 95.8381 173.685 96.9668 173.014 97.6012L168.179 102.177C167.907 102.434 167.788 102.815 167.867 103.182L169.297 109.858C169.498 110.798 168.457 111.509 167.655 110.98L162.496 107.577Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselImage3);
export default __webpack_public_path__ + "static/media/CarouselImage3.fe4b6baecce1dbfab844e4d4e3caa248.svg";
export { ForwardRef as ReactComponent };